<template>
  <v-card
    :aria-label="`Vai a ${proposal.name}`"
    rounded="sm"
    :href="link"
    @click.prevent="handleLink"
    elevation="0"
    class="proposal-img"
    v-intersect.once="handleView"
  >
    <v-img
      eager
      :src="src"
      :alt="proposal.name"
      :id="`proposal-image-${proposal.id}`"
    >
      <div
        v-if="proposal.content"
        class="overlay"
        v-html="proposal.content"
      ></div>
      <v-btn
        v-if="$ebsn.meta(proposal, 'category_proposal_type.SHOW_BTN', false)"
        :href="link"
        @click.prevent="handleLink"
        color="secondary"
        block
        depressed
      >
        Scopri di più
      </v-btn>
    </v-img>

    <div class="proposal-img-title d-block mx-auto text-center" v-if="title">
      {{ title }}
    </div>
  </v-card>
</template>
<style lang="scss">
.proposal-img-title {
  font-weight: 600;
  font-family: "Open Sans";
  color: var(--v--primary-base);
  font-size: 12px;
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    font-size: 16px;
  }
}
</style>
<script>
import get from "lodash/get";
import banner from "~/mixins/banner";
export default {
  name: "ProposalImage",
  mixins: [banner],
  computed: {
    title() {
      return this.$ebsn.meta(this.proposal, "category_proposal_type.TITLE");
    },
    src() {
      let isXs = this.$vuetify.breakpoint.xsOnly;

      let prop =
        "metaData.category_proposal_type." +
        (isXs ? "IMAGE_MOBILE" : "IMAGE_DESKTOP");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
